import { UserManager } from 'oidc-client-ts';
import { oidcConfiguration } from 'services/oidc-config-provider';

// One `UserManager` instance is created once and shared, because both React(`AuthProvider` / `useAuth()`) and
// non - React code(Apollo link, SignalR) need the same tokens.
// Two instances would fight over the same storage — one refreshes while the other serves a stale token, 
// causing random 401s and double renew timers.

export const userManager = new UserManager(oidcConfiguration);
